export default __webpack_public_path__ + "static/media/meetpharma-offre-parrainage.f97eb847.png";